module.exports = __webpack_public_path__ + "static/graphik-bold-d818a0ff3d2e9abc06721196728d1a19.woff2";